<template>
<div>
    <v-row no-gutters align="center" v-for="(item, index) in weather" :key="index">
        <v-col cols="4" class="text-xs-center">
            <p class="mb-0">{{ item.month }}</p>
        </v-col>
        <v-col cols="2" class="pa-1">
            <v-text-field label="High" v-model="item.high" class="ma-0 pa-0" type="number"></v-text-field>
        </v-col>
        <v-col cols="2" class="pa-1">
            <v-text-field label="Medium" v-model="item.medium" class="ma-0 pa-0" type="number"></v-text-field>
        </v-col>
        <v-col cols="2" class="pa-1">
            <v-text-field label="Low" v-model="item.low" class="ma-0 pa-0" type="number"></v-text-field>
        </v-col>
        <v-col cols="2" class="pa-1">
            <v-select :items="icon" label="Weather icon" item-value="slug" v-model="item.weather" class="ma-0 pa-0">
                <template v-slot:selection="data">
                    <v-row style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:150px" align="center" no-gutters>
                        <!-- <v-icon>{{ data.item.icon_name }}</v-icon> -->
                        <v-img max-width="30" :src="data.item.icon_name"></v-img>
                    </v-row>
                </template>
                <template v-slot:item="data">
                    <v-card tile flat style="background: transparent;">
                        <!-- <v-icon>{{ data.item.icon_name }}</v-icon> -->
                        <v-avatar size="36px">
                            <img :src="data.item.icon_name" alt="alt">
                        </v-avatar>
                    </v-card>
                </template>
            </v-select>
        </v-col>
    </v-row>
</div>
</template>

<script>
//	import defaults from "../components/utils/PropDefaults.js";
import cloud from "../../../assets/weather_icons/cloud.svg"
import cloud_drizzle from "../../../assets/weather_icons/cloud-drizzle.svg"
import cloud_drizzle_lightning from "../../../assets/weather_icons/cloud-drizzle-lightning.svg"
import cloud_drizzle_lightning_moon from "../../../assets/weather_icons/cloud-drizzle-lightning-moon.svg"
import cloud_drizzle_lightning_sun from "../../../assets/weather_icons/cloud-drizzle-lightning-sun.svg"
import cloud_drizzle_lightning_sun_2 from "../../../assets/weather_icons/cloud-drizzle-lightning-sun-2.svg"
import cloud_drizzle_moon from "../../../assets/weather_icons/cloud-drizzle-moon.svg"
import cloud_drizzle_sun from "../../../assets/weather_icons/cloud-drizzle-sun.svg"
import cloud_drizzle_sun_2 from "../../../assets/weather_icons/cloud-drizzle-sun-2.svg"
import cloud_fog from "../../../assets/weather_icons/cloud-fog.svg"
import cloud_fog_2 from "../../../assets/weather_icons/cloud-fog-2.svg"
import cloud_fog_moon from "../../../assets/weather_icons/cloud-fog-moon.svg"
import cloud_fog_sun from "../../../assets/weather_icons/cloud-fog-sun.svg"
import cloud_fog_sun_2 from "../../../assets/weather_icons/cloud-fog-sun-2.svg"
import cloud_hail from "../../../assets/weather_icons/cloud-hail.svg"
import cloud_hail_lightning from "../../../assets/weather_icons/cloud-hail-lightning.svg"
import cloud_hail_lightning_moon from "../../../assets/weather_icons/cloud-hail-lightning-moon.svg"
import cloud_hail_lightning_sun from "../../../assets/weather_icons/cloud-hail-lightning-sun.svg"
import cloud_hail_lightning_sun_2 from "../../../assets/weather_icons/cloud-hail-lightning-sun-2.svg"
import cloud_hail_moon from "../../../assets/weather_icons/cloud-hail-moon.svg"
import cloud_hail_sun from "../../../assets/weather_icons/cloud-hail-sun.svg"
import cloud_hail_sun_2 from "../../../assets/weather_icons/cloud-hail-sun-2.svg"
import cloud_lightning from "../../../assets/weather_icons/cloud-lightning.svg"
import cloud_lightning_moon from "../../../assets/weather_icons/cloud-lightning-moon.svg"
import cloud_lightning_sun from "../../../assets/weather_icons/cloud-lightning-sun.svg"
import cloud_lightning_sun_2 from "../../../assets/weather_icons/cloud-lightning-sun-2.svg"
import cloud_moon from "../../../assets/weather_icons/cloud-moon.svg"
import cloud_rain from "../../../assets/weather_icons/cloud-rain.svg"
import cloud_rain_2 from "../../../assets/weather_icons/cloud-rain-2.svg"
import cloud_rain_2_moon from "../../../assets/weather_icons/cloud-rain-2-moon.svg"
import cloud_rain_2_sun from "../../../assets/weather_icons/cloud-rain-2-sun.svg"
import cloud_rain_2_sun_2 from "../../../assets/weather_icons/cloud-rain-2-sun-2.svg"
import cloud_rain_lightning from "../../../assets/weather_icons/cloud-rain-lightning.svg"
import cloud_rain_lightning_moon from "../../../assets/weather_icons/cloud-rain-lightning-moon.svg"
import cloud_rain_lightning_sun from "../../../assets/weather_icons/cloud-rain-lightning-sun.svg"
import cloud_rain_lightning_sun_2 from "../../../assets/weather_icons/cloud-rain-lightning-sun-2.svg"
import cloud_rain_moon from "../../../assets/weather_icons/cloud-rain-moon.svg"
import cloud_rain_sun from "../../../assets/weather_icons/cloud-rain-sun.svg"
import cloud_rain_sun_2 from "../../../assets/weather_icons/cloud-rain-sun-2.svg"
import clouds from "../../../assets/weather_icons/clouds.svg"
import clouds_moon from "../../../assets/weather_icons/clouds-moon.svg"
import cloud_snow from "../../../assets/weather_icons/cloud-snow.svg"
import cloud_snow_moon from "../../../assets/weather_icons/cloud-snow-moon.svg"
import cloud_snow_sun from "../../../assets/weather_icons/cloud-snow-sun.svg"
import cloud_snow_sun_2 from "../../../assets/weather_icons/cloud-snow-sun-2.svg"
import clouds_sun from "../../../assets/weather_icons/clouds-sun.svg"
import clouds_sun_2 from "../../../assets/weather_icons/clouds-sun-2.svg"
import cloud_sun from "../../../assets/weather_icons/cloud-sun.svg"
import cloud_sun_2 from "../../../assets/weather_icons/cloud-sun-2.svg"
import cloud_wind from "../../../assets/weather_icons/cloud-wind.svg"
import cloud_wind_2 from "../../../assets/weather_icons/cloud-wind-2.svg"
import cloud_wind_2_moon from "../../../assets/weather_icons/cloud-wind-2-moon.svg"
import cloud_wind_2_sun from "../../../assets/weather_icons/cloud-wind-2-sun.svg"
import cloud_wind_2_sun_2 from "../../../assets/weather_icons/cloud-wind-2-sun-2.svg"
import cloud_wind_moon from "../../../assets/weather_icons/cloud-wind-moon.svg"
import cloud_wind_sun from "../../../assets/weather_icons/cloud-wind-sun.svg"
import cloud_wind_sun_2 from "../../../assets/weather_icons/cloud-wind-sun-2.svg"
import drizzle from "../../../assets/weather_icons/drizzle.svg"
import fog from "../../../assets/weather_icons/fog.svg"
import hail from "../../../assets/weather_icons/hail.svg"
import lightning from "../../../assets/weather_icons/lightning.svg"
import moon_25 from "../../../assets/weather_icons/moon-25.svg"
import moon_50 from "../../../assets/weather_icons/moon-50.svg"
import moon_75 from "../../../assets/weather_icons/moon-75.svg"
import moon_100 from "../../../assets/weather_icons/moon-100.svg"
import moon_stars from "../../../assets/weather_icons/moon-stars.svg"
import rain from "../../../assets/weather_icons/rain.svg"
import raindrop from "../../../assets/weather_icons/raindrop.svg"
import snow from "../../../assets/weather_icons/snow.svg"
import sun from "../../../assets/weather_icons/sun.svg"
import sun_eclipse from "../../../assets/weather_icons/sun-eclipse.svg"
import sun_low from "../../../assets/weather_icons/sun-low.svg"
import sun_lower from "../../../assets/weather_icons/sun-lower.svg"
import sun_rise from "../../../assets/weather_icons/sun-rise.svg"
import sun_set from "../../../assets/weather_icons/sun-set.svg"
import thermometer_25 from "../../../assets/weather_icons/thermometer-25.svg"
import thermometer_50 from "../../../assets/weather_icons/thermometer-50.svg"
import thermometer_75 from "../../../assets/weather_icons/thermometer-75.svg"
import thermometer_100 from "../../../assets/weather_icons/thermometer-100.svg"
import tornado from "../../../assets/weather_icons/tornado.svg"
import umbrella from "../../../assets/weather_icons/umbrella.svg"
import umbrella_drizzle from "../../../assets/weather_icons/umbrella-drizzle.svg"
import wet from "../../../assets/weather_icons/wet.svg"
import wind from "../../../assets/weather_icons/wind.svg"
export default {
    components: {

    },
    props: {
        weather: {
            type: Array,

        }
    },
    data() {
        return {
            // cloud: cloud,
            icon: [
                {
                    icon_name: cloud,
                    slug: "cloud"
                },
                {
                    icon_name: cloud_drizzle,
                    slug: "cloud_drizzle"
                },
                {
                    icon_name: cloud_drizzle_lightning,
                    slug: "cloud_drizzle_lightning"
                },
                {
                    icon_name: cloud_drizzle_lightning_moon,
                    slug: "cloud_drizzle_lightning_moon"
                },
                {
                    icon_name: cloud_drizzle_lightning_sun,
                    slug: "cloud_drizzle_lightning_sun"
                },
                {
                    icon_name: cloud_drizzle_lightning_sun_2,
                    slug: "cloud_drizzle_lightning_sun_2"
                },
                {
                    icon_name: cloud_drizzle_moon,
                    slug: "cloud_drizzle_moon"
                },
                {
                    icon_name: cloud_drizzle_sun,
                    slug: "cloud_drizzle_sun"
                },
                {
                    icon_name: cloud_drizzle_sun_2,
                    slug: "cloud_drizzle_sun_2"
                },
                {
                    icon_name: cloud_fog,
                    slug: "cloud_fog"
                },
                {
                    icon_name: cloud_fog_2,
                    slug: "cloud_fog_2"
                },
                {
                    icon_name: cloud_fog_moon,
                    slug: "cloud_fog_moon"
                },
                {
                    icon_name: cloud_fog_sun,
                    slug: "cloud_fog_sun"
                },
                {
                    icon_name: cloud_fog_sun_2,
                    slug: "cloud_fog_sun_2"
                },
                {
                    icon_name: cloud_hail,
                    slug: "cloud_hail"
                },
                {
                    icon_name: cloud_hail_lightning,
                    slug: "cloud_hail_lightning"
                },
                {
                    icon_name: cloud_hail_lightning_moon,
                    slug: "cloud_hail_lightning_moon"
                },
                {
                    icon_name: cloud_hail_lightning_sun,
                    slug: "cloud_hail_lightning_sun"
                },
                {
                    icon_name: cloud_hail_lightning_sun_2,
                    slug: "cloud_hail_lightning_sun_2"
                },
                {
                    icon_name: cloud_hail_moon,
                    slug: "cloud_hail_moon"
                },
                {
                    icon_name: cloud_hail_sun,
                    slug: "cloud_hail_sun"
                },
                {
                    icon_name: cloud_hail_sun_2,
                    slug: "cloud_hail_sun_2"
                },
                {
                    icon_name: cloud_lightning,
                    slug: "cloud_lightning"
                },
                {
                    icon_name: cloud_lightning_moon,
                    slug: "cloud_lightning_moon"
                },
                {
                    icon_name: cloud_lightning_sun,
                    slug: "cloud_lightning_sun"
                },
                {
                    icon_name: cloud_moon,
                    slug: "cloud_moon"
                },
                {
                    icon_name: cloud_rain,
                    slug: "cloud_rain"
                },
                {
                    icon_name: cloud_rain_2,
                    slug: "cloud_rain_2"
                },
                {
                    icon_name: cloud_rain_2_moon,
                    slug: "cloud_rain_2_moon"
                },
                {
                    icon_name: cloud_rain_2_sun,
                    slug: "cloud_rain_2_sun"
                },
                {
                    icon_name: cloud_rain_2_sun_2,
                    slug: "cloud_rain_2_sun_2"
                },
                {
                    icon_name: cloud_rain_lightning,
                    slug: "cloud_rain_lightning"
                },
                {
                    icon_name: cloud_rain_lightning_moon,
                    slug: "cloud_rain_lightning_moon"
                },
                {
                    icon_name: cloud_rain_lightning_sun,
                    slug: "cloud_rain_lightning_sun"
                },
                {
                    icon_name: cloud_rain_lightning_sun_2,
                    slug: "cloud_rain_lightning_sun_2"
                },
                {
                    icon_name: cloud_rain_moon,
                    slug: "cloud_rain_moon"
                },
                {
                    icon_name: cloud_rain_sun,
                    slug: "cloud_rain_sun"
                },
                {
                    icon_name: cloud_rain_sun_2,
                    slug: "cloud_rain_sun_2"
                },
                {
                    icon_name: clouds,
                    slug: "clouds"
                },
                {
                    icon_name: clouds_moon,
                    slug: "clouds_moon"
                },
                {
                    icon_name: cloud_snow,
                    slug: "cloud_snow"
                },
                {
                    icon_name: cloud_snow_moon,
                    slug: "cloud_snow_moon"
                },
                {
                    icon_name: cloud_snow_sun,
                    slug: "cloud_snow_sun"
                },
                {
                    icon_name: cloud_snow_sun_2,
                    slug: "cloud_snow_sun_2"
                },
                {
                    icon_name: clouds_sun,
                    slug: "clouds_sun"
                },
                {
                    icon_name: clouds_sun_2,
                    slug: "clouds_sun_2"
                },
                {
                    icon_name: cloud_sun,
                    slug: "cloud_sun"
                },
                {
                    icon_name: cloud_sun_2,
                    slug: "cloud_sun_2"
                },
                {
                    icon_name: cloud_wind,
                    slug: "cloud_wind"
                },
                {
                    icon_name: cloud_wind_2,
                    slug: "cloud_wind_2"
                },
                {
                    icon_name: cloud_wind_2_moon,
                    slug: "cloud_wind_2_moon"
                },
                {
                    icon_name: cloud_wind_2_sun,
                    slug: "cloud_wind_2_sun"
                },
                {
                    icon_name: cloud_wind_2_sun_2,
                    slug: "cloud_wind_2_sun_2"
                },
                {
                    icon_name: cloud_wind_moon,
                    slug: "cloud_wind_moon"
                },
                {
                    icon_name: cloud_wind_sun,
                    slug: "cloud_wind_sun"
                },
                {
                    icon_name: cloud_wind_sun_2,
                    slug: "cloud_wind_sun_2"
                },
                {
                    icon_name: drizzle,
                    slug: "drizzle"
                },
                {
                    icon_name: fog,
                    slug: "fog"
                },
                {
                    icon_name: hail,
                    slug: "hail"
                },
                {
                    icon_name: lightning,
                    slug: "lightning"
                },
                {
                    icon_name: moon_25,
                    slug: "moon_25"
                },
                {
                    icon_name: moon_50,
                    slug: "moon_50"
                },
                {
                    icon_name: moon_75,
                    slug: "moon_75"
                },
                {
                    icon_name: moon_100,
                    slug: "moon_100"
                },
                {
                    icon_name: moon_stars,
                    slug: "moon_stars"
                },
                {
                    icon_name: rain,
                    slug: "rain"
                },
                {
                    icon_name: raindrop,
                    slug: "raindrop"
                },
                {
                    icon_name: snow,
                    slug: "snow"
                },
                {
                    icon_name: sun,
                    slug: "sun"
                },
                {
                    icon_name: sun_eclipse,
                    slug: "sun_eclipse"
                },
                {
                    icon_name: sun_low,
                    slug: "sun_low"
                },
                {
                    icon_name: sun_lower,
                    slug: "sun_lower"
                },
                {
                    icon_name: sun_rise,
                    slug: "sun_rise"
                },
                {
                    icon_name: sun_set,
                    slug: "sun_set"
                },
                {
                    icon_name: thermometer_25,
                    slug: "thermometer_25"
                },
                {
                    icon_name: thermometer_50,
                    slug: "thermometer_50"
                },
                {
                    icon_name: thermometer_75,
                    slug: "thermometer_75"
                },
                {
                    icon_name: thermometer_100,
                    slug: "thermometer_100"
                },
                {
                    icon_name: tornado,
                    slug: "tornado"
                },
                {
                    icon_name: umbrella,
                    slug: "umbrella"
                },
                {
                    icon_name: umbrella_drizzle,
                    slug: "umbrella_drizzle"
                },
                {
                    icon_name: wet,
                    slug: "wet"
                },
                {
                    icon_name: wind,
                    slug: "wind"
                }
			],
        }
    }
}
</script>

<style scoped>

</style>
